<template>
  <a :href="session.teacherUrl" v-bind:key="session.id" v-for="session in sessions" class="bg-green/20 border rounded-md mb-2 p-4 mt-2 flex justify-between items-center">
    <span v-if="!withYear">{{ session.friendlyTime }}</span>
    <span v-else>{{ session.friendlyTimeWithYear }}</span>
    <span v-if="session.students"
      :class="session.students.length > 0 ? 'font-medium text-green-700' : 'opacity-70'"
      class="text-sm"
    >
      {{ session.students.length }} student{{ session.students.length > 1 ? 's' : '' }}
    </span>
  </a>
</template>

<script setup>
import { onMounted, ref } from 'vue';

let props = defineProps({
  sessions: Array,
  withYear: {
    type: Boolean,
    default: false
  },
});

//
// onMounted(() => {
//   fetchSessions()
// });
//
// const fetchSessions = () => {
//   // fetch from api/sessions/one?sessionId=props.sessionId
//   fetch('/api/sessions/all?classId=' + props.classId)
//       .then((response) => {
//         if (response.ok) {
//           return response.json();
//         }
//       })
//       .then((response) => {
//         console.log(response);
//         sessions.value = response.sessions;
//         console.log(sessions.value);
//       });
// }
</script>